<div class="dialog" [attr.data-testid]="data.testId">
  <button class="dialog__close" (click)="closeDialog()">
    <fr8bot-ui-icon name="menu-x" [size]="16" />
  </button>

  <div class="tw:flex tw:h-full tw:items-center tw:justify-center tw:p-5">
    <div class="tw:flex tw:flex-col tw:items-center tw:text-gray-3">
      <fr8bot-ui-icon name="congratulation-100" [size]="100" />

      <div class="tw:typography-headline-1 tw:mt-5 tw:text-white">
        {{ data.title | translate }}!
      </div>
      <div class="tw:typography-subHeadline tw:mt-2 tw:max-w-[350px] tw:text-center">
        {{ data.text | translate }}
      </div>
      <fr8bot-ui-button
        (click)="closeDialog()"
        type="primaryCut"
        class="tw:mt-10 tw:w-full tw:max-w-[230px]"
      >
        {{ data.buttonText | translate }}
      </fr8bot-ui-button>
    </div>
  </div>
</div>
